function Reports() {
  return (
    <div>
      <h1>レポート</h1>
    </div>
  );
}
export default Reports;
